var _path, _path2;
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
var Image = function Image(_ref) {
  var _ref$className = _ref.className,
    className = _ref$className === void 0 ? 'tw-text-neutral-light-800' : _ref$className,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? 32 : _ref$size;
  return /*#__PURE__*/_jsxs("svg", {
    className: className,
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    children: [_path || (_path = /*#__PURE__*/_jsx("path", {
      d: "M15 7a1 1 0 1 0 0 2h.01a1 1 0 1 0 0-2H15Z",
      fill: "none",
      className: "tw-fill-current"
    })), _path2 || (_path2 = /*#__PURE__*/_jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M21 15.001V17a4 4 0 0 1-4 4H7a4 4 0 0 1-4-4V7a4 4 0 0 1 4-4h10a4 4 0 0 1 4 4v8.001ZM5 7a2 2 0 0 1 2-2h10a2 2 0 0 1 2 2v5.586l-.293-.293-.014-.014c-.602-.58-1.357-.949-2.193-.949-.836 0-1.591.37-2.193.95l-.014.013-.293.293-2.293-2.293-.014-.014c-.602-.58-1.357-.949-2.193-.949-.836 0-1.591.37-2.193.95l-.014.013L5 12.586V7Zm10.414 7 .286-.286c.307-.293.584-.384.8-.384.216 0 .493.091.8.385l1.7 1.7V17a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2v-1.586l3.7-3.7c.307-.293.584-.384.8-.384.216 0 .493.091.8.385l4.993 4.992a1 1 0 0 0 1.414-1.414L15.414 14Z",
      fill: "none",
      className: "tw-fill-current"
    }))]
  });
};
export default Image;